@use '@/styles/mixins' as *;

.address {
  @include truncate(2);
}

.lines {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 0;
}

.line {
  @include truncate;
  max-width: 100%;
}
